import './BillingInformationTab.scss';
import { BillingInformationContent } from 'pages/Profile/components/Billing/BillingInformation/BillingInformation';
import { useGetUserBillingInfo } from 'queryHooks/Profile/Billing/useGetBillingInfo';
import { useTranslation } from 'react-i18next';
import { BillingInfo } from 'types/billing';

export const BillingInformationTab = () => {
  const { data: billingInfo, isPending: isBillingInfoPending } = useGetUserBillingInfo();

  return !isBillingInfoPending ? <BillingContent billingInfo={billingInfo} /> : <></>;
};

const BillingContent = ({ billingInfo }: { billingInfo: BillingInfo | string | undefined }) => {
  const { t } = useTranslation();

  return (
    <div className='profile-section billing-information-section'>
      {typeof billingInfo === 'string' || billingInfo === undefined ? (
        <div className='no-billing-info'>
          <h3>{t('NoBillingInformation', { ns: 'billingInformation' })}</h3>
        </div>
      ) : (
        <BillingInformationContent billingInfo={billingInfo} />
      )}
    </div>
  );
};
